import { useLayoutEffect, useEffect } from 'react'
import { isServer } from 'app/presentation/utils/isServer'

const useIsomorphicEffect = isServer ? useEffect : useLayoutEffect

export { useIsomorphicEffect }
